<template>
    <v-chip
        v-if="displayStatus"
        class="label-chip"
        :color="this.displayStatus.color"
        label
    >
        <v-icon left>
            {{ this.displayStatus.icon }}
        </v-icon>
        {{ this.displayStatus.name }}
    </v-chip>
</template>
<script>
    export default {
        props: {
            status: {
                type: String,
                required: true
            }
        },
        computed: {
            config() {
                return this.$store.getters.getConfig || {}
            },
            statuses() {
                return this.config?.assignmentStatuses || []
            },
            displayStatus() {
                return this.statuses.find(st => st.value === this.status)
            }
        }
    }
</script>
<style scoped>
.label-chip {
    color: whitesmoke;
}
</style>
